import { ISelectValues } from "../../../component/ISelectValues";

export const ID_OPEN = 'OPEN';
export const ID_TO_SEND = 'TO_SEND';
export const ID_SENT = 'SENT';
export const ID_ACCOUNTED = 'ACCOUNTED';
export const ID_UNACCOUNTED = 'UNACCOUNTED';
export const ID_REISSUED = 'REISSUED';
export const TO_BE_ACCOUNTED = "TO_BE_ACCOUNTED";
export const SENT_FOR_ACCOUNTED = "SENT_FOR_ACCOUNTED";
export const ID_CANCELLED = "CANCELLED";
export const CANCELLED_INVOICE = "CANCELLED_INVOICE";
export const ID_SUB_OOFC_UNPAID = "SUB_OOFC_UNPAID";
export const ID_SUB_OOFC_PENDING = "SUB_OOFC_PENDING";

export const statuses: ISelectValues[] = [
    {
      value: "TO_SEND",
      label: "statuses.TO_SEND"
    },
    {
      value: "SENT",
      label: "statuses.SENT"
    },
    {
      value: "ACCOUNTED",
      label: "statuses.ACCOUNTED"
    },
    {
      value: "UNACCOUNTED",
      label: "statuses.UNACCOUNTED"
    },
    {
      value: "REISSUED",
      label: "statuses.REISSUED"
    },
    {
      value: "TO_BE_ACCOUNTED",
      label: "statuses.TO_BE_ACCOUNTED"
    },
    {
      value: "SENT_FOR_ACCOUNTED",
      label: "statuses.SENT_FOR_ACCOUNTED"
    },
    {
      value: "OPEN",
      label: "statuses.OPEN"
    },
    {
      value: "CANCELLED",
      label: "statuses.CANCELLED"
    },
    {
      value: "SUB_OOFC_UNPAID",
      label: "statuses.SUB_OOFC_UNPAID"
    },
    {
      value: "SUB_OOFC_PENDING",
      label: "statuses.SUB_OOFC_PENDING"
    }
  ];

export const leasePlanStatuses: ISelectValues[] = [
    {
        value: "APPROVED",
        label: "leasePlan.statuses.APPROVED"
    },
    {
        value: "REJECTED",
        label: "leasePlan.statuses.REJECTED"
    },
    {
        value: "PARTIALLY_PROCESSED",
        label: "leasePlan.statuses.PARTIALLY_PROCESSED"
    },
    {
        value: "PARTIALLY_APPROVED",
        label: "leasePlan.statuses.PARTIALLY_APPROVED"
    },
    {
        value: "WAITING",
        label: "leasePlan.statuses.WAITING"
    }
];

export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : "";
  }
